module.exports = __webpack_public_path__ + "img/id3.3343b83e.png";